module.exports = __webpack_public_path__ + "static/img/yidi4.6b4674a4.webp";